function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Row, Col, Button, Label } from 'reactstrap';
import { v4 as uuidV4 } from 'uuid';
import moment from 'moment';
import AssetDetailsItemDetailDescription from './assetDetailsItemDetailDescription';
import SurfaceAreaCalcModal from '../common/calculators/surfaceArea/surfaceAreaCalcModal';
import { removeItemWithConfirm } from '../common/classes/handleItemWithConfirm';
import entityComposition from '../common/classes/entityComposition';
import AssetDetailsConditionItem from './assetDetailsConditionItem';
import SegmentedPicker from '../common/controls/segmentedPicker';
import SinglePicker from '../common/controls/singlePicker';
import NumberInput from '../common/controls/numberInput';
import TextInput from '../common/controls/textInput';
import PhotoItem from '../common/sections/photoItem';
import Icon from '../common/containers/icon';

// must be defined outside of the component to avoid re-rendering loops
const noop = () => {};
const confirmOnRemoveFields = ['coated', 'visualInspection', 'exclude', 'assetCoatingSubstrateID', 'partIdentifier', 'surfaceArea', 'comments', 'assetCoatingDetailID', 'assetCoatingDetailDescriptionID', 'assetCoatingDetailDescriptionOther', 'photos', 'conditions'];
const defaultEntity = (assetCoatingSetID, appCreatorID) => {
  const createdDate = moment().utc().toISOString();
  return {
    id: uuidV4().toUpperCase(),
    appCreatorID,
    // logged in user
    appCreated: createdDate,
    created: createdDate,
    assetCoatingSetID // detailID
  };
};
class AssetDetailsItem extends Component {
  constructor(props) {
    super(props);
    const {
      detailIndex,
      onChange
    } = props;
    this.handleChange = (name, value) => onChange(`details[${detailIndex}]/${name}`, value);
    this.state = {
      showCalculate: false
    };
    this.handleCalculateClose = this.handleCalculateClose.bind(this);
    this.handleCalculateShow = this.handleCalculateShow.bind(this);
    this.handleCalculateSave = this.handleCalculateSave.bind(this);
    this.handleAddPhoto = this.handleAddPhoto.bind(this);
    this.handleRemovePhoto = this.handleRemovePhoto.bind(this);
    this.handleChangePhoto = this.handleChangePhoto.bind(this);
    this.handleUploadPhoto = this.handleUploadPhoto.bind(this);
    this.handleAddCondition = this.handleAddCondition.bind(this);
    this.handleRemoveCondition = this.handleRemoveCondition.bind(this);
    this.handleChangeCondition = this.handleChangeCondition.bind(this);
    this.handleRemoveAssetDetail = this.handleRemoveAssetDetail.bind(this);
  }
  componentDidMount() {
    const {
      assetCoatingSubstrate,
      assetCoatingSubstrateActions
    } = this.props;
    assetCoatingSubstrateActions.serverIndex(assetCoatingSubstrate.indexQuery);
  }
  handleCalculateClose() {
    this.setState({
      showCalculate: false
    });
  }
  handleCalculateShow() {
    this.setState({
      showCalculate: true
    });
  }
  handleCalculateSave(result) {
    this.setState({
      showCalculate: false
    });
    this.handleChange('surfaceArea', result);
  }
  handleAddCondition() {
    const {
      userID,
      detail: {
        id: detailID,
        conditions
      }
    } = this.props;
    const newConditions = JSON.parse(JSON.stringify(conditions));
    newConditions.push(defaultEntity(detailID, userID));
    this.handleChange('conditions', newConditions);
  }
  handleRemoveCondition(conditionIndex) {
    const {
      detail: {
        conditions
      }
    } = this.props;
    const newConditions = JSON.parse(JSON.stringify(conditions));
    newConditions.splice(conditionIndex, 1);
    this.handleChange('conditions', newConditions);
  }
  handleChangeCondition(conditionIndex, fieldName, value) {
    const {
      detailIndex,
      onChange
    } = this.props;
    onChange(`details[${detailIndex}]/conditions[${conditionIndex}]/${fieldName}`, value);
  }
  handleAddPhoto() {
    const {
      userID,
      detail: {
        id: detailID,
        photos
      }
    } = this.props;
    const newPhotos = JSON.parse(JSON.stringify(photos));
    newPhotos.push(defaultEntity(detailID, userID));
    this.handleChange('photos', newPhotos);
  }
  handleRemovePhoto(photoIndex) {
    const {
      detail: {
        photos
      }
    } = this.props;
    const newPhotos = JSON.parse(JSON.stringify(photos));
    newPhotos.splice(photoIndex, 1);
    this.handleChange('photos', newPhotos);
  }
  handleChangePhoto(photoIndex, {
    name: fieldName,
    value
  }) {
    const {
      detailIndex,
      onChange
    } = this.props;
    onChange(`details[${detailIndex}]/photos[${photoIndex}]/${fieldName}`, value);
  }
  handleUploadPhoto(incomingItem, photoIndex, filesToUpload) {
    if (filesToUpload.length) {
      const {
        detail: {
          assetID
        },
        detailIndex,
        serverUpload
      } = this.props;
      const pathPrefix = `details/${detailIndex}/photos/${photoIndex}`;
      serverUpload(assetID, `${pathPrefix}/path`, `${pathPrefix}/tempPath`, [_objectSpread(_objectSpread({}, incomingItem), {}, {
        rawFile: filesToUpload[0],
        remotePath: `${uuidV4().toUpperCase()}.jpg`,
        type: filesToUpload[0].type
      })]);
    }
  }
  handleRemoveAssetDetail() {
    const {
      detailIndex,
      onRemove,
      detail
    } = this.props;
    removeItemWithConfirm(detail, 'asset detail', confirmOnRemoveFields, () => onRemove(detailIndex));
  }
  render() {
    const {
      showCalculate
    } = this.state;
    const {
      detail,
      detailIndex,
      assetCoatingSubstrate,
      loading
    } = this.props;
    const {
      assetCoatingSubstrateID,
      coated,
      comments,
      conditions,
      exclude,
      photos,
      surfaceArea,
      visualInspection
    } = detail;
    const handleChangeAssetCoatingSubstrateID = value => this.handleChange('assetCoatingSubstrateID', value);
    const handleChangeCoated = value => this.handleChange('coated', value);
    const handleChangeExclude = value => this.handleChange('exclude', value);
    const handleChangeSurfaceArea = value => this.handleChange('surfaceArea', value);
    const handleChangeVisualInspection = value => this.handleChange('visualInspection', value);
    return /*#__PURE__*/React.createElement("section", {
      className: `t-adi-${detailIndex}`
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: {
        size: 3,
        offset: 9
      }
    }, /*#__PURE__*/React.createElement(Button, {
      size: "sm",
      className: "float-md-right form-control t-ad-remove-detail tqc-control",
      onClick: this.handleRemoveAssetDetail
    }, /*#__PURE__*/React.createElement(Icon, {
      glyph: "trash"
    }), " Remove Detail"))), /*#__PURE__*/React.createElement(AssetDetailsItemDetailDescription, {
      detail: detail,
      onChange: this.handleChange
    }), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 2
    }, /*#__PURE__*/React.createElement(SegmentedPicker, {
      className: "t-adi-coated",
      names: ['Yes', 'No'],
      values: [1, 0],
      label: "Coated",
      onChange: handleChangeCoated,
      value: coated
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 2
    }, /*#__PURE__*/React.createElement(SegmentedPicker, {
      className: "t-adi-visual-inspection",
      names: ['Yes', 'No'],
      values: [1, 0],
      label: "Visual Inspection",
      onChange: handleChangeVisualInspection,
      value: visualInspection
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 2
    }, /*#__PURE__*/React.createElement(SegmentedPicker, {
      className: "t-adi-exclude",
      names: ['Yes', 'No'],
      values: [1, 0],
      label: "Exclude",
      onChange: handleChangeExclude,
      value: exclude
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 4
    }, /*#__PURE__*/React.createElement(SinglePicker, {
      label: "Substrate",
      labelKey: "name",
      onChange: handleChangeAssetCoatingSubstrateID,
      options: assetCoatingSubstrate.list,
      placeholder: "Select...",
      value: assetCoatingSubstrateID,
      returnValueKey: "id"
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 4
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: "Part ID",
      field: "partIdentifier",
      data: detail,
      onChange: this.handleChange,
      entity: "AssetCoatingSet"
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 2
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: "Surface Area",
      onChange: handleChangeSurfaceArea,
      entity: "AssetCoatingSet",
      field: "surfaceArea",
      value: surfaceArea
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 2
    }, /*#__PURE__*/React.createElement("div", {
      className: "form-group"
    }, /*#__PURE__*/React.createElement(Label, {
      className: "control-label",
      htmlFor: "control"
    }, /*#__PURE__*/React.createElement("span", null, "\xA0")), /*#__PURE__*/React.createElement(Button, {
      size: "sm",
      onClick: this.handleCalculateShow,
      className: "form-control t-ad-calculate tqc-control tqc-control"
    }, "Calculate")))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 8
    }, /*#__PURE__*/React.createElement(TextInput, {
      id: "assetDetailsItemComments",
      type: "textarea",
      field: "comments",
      label: "Comments",
      value: comments || '',
      onChange: this.handleChange,
      style: {
        minHeight: '110px',
        height: '72px',
        resize: 'vertical'
      }
    }))), (conditions || []).map((nextCondition, conditionIndex) => /*#__PURE__*/React.createElement(AssetDetailsConditionItem, {
      condition: nextCondition,
      conditionIndex: conditionIndex,
      key: nextCondition.id,
      onChange: this.handleChangeCondition,
      onRemove: this.handleRemoveCondition
    })), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: {
        size: 3,
        offset: 9
      }
    }, /*#__PURE__*/React.createElement(Button, {
      size: "sm",
      onClick: this.handleAddCondition,
      className: "float-md-right form-control t-ad-add-condition tqc-control"
    }, /*#__PURE__*/React.createElement(Icon, {
      glyph: "plus"
    }), " Add Condition"))), (photos || []).map((item, index) => /*#__PURE__*/React.createElement(PhotoItem, {
      data: item,
      index: index,
      key: item.id,
      loading: loading,
      marginTop: "20px",
      onChange: this.handleChangePhoto,
      onRemove: this.handleRemovePhoto,
      onUpload: this.handleUploadPhoto,
      setSaveStatus: noop,
      includeDivider: true,
      hasCaption: true
    })), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: {
        size: 3,
        offset: 9
      }
    }, /*#__PURE__*/React.createElement(Button, {
      size: "sm",
      onClick: this.handleAddPhoto,
      className: "float-md-right form-control t-ad-add-photo tqc-control",
      style: {
        marginTop: '15px'
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      glyph: "plus"
    }), " Add Photo"))), /*#__PURE__*/React.createElement(SurfaceAreaCalcModal, {
      show: showCalculate,
      onHide: this.handleCalculateClose,
      onSave: this.handleCalculateSave
    }), /*#__PURE__*/React.createElement("hr", null));
  }
}
AssetDetailsItem.propTypes = {
  detail: PropTypes.shape({
    id: PropTypes.string,
    conditions: PropTypes.arrayOf(PropTypes.shape({})),
    comments: PropTypes.string,
    photos: PropTypes.arrayOf(PropTypes.shape({})),
    surfaceArea: PropTypes.number,
    assetCoatingSubstrateID: PropTypes.string,
    exclude: PropTypes.number,
    visualInspection: PropTypes.number,
    coated: PropTypes.number,
    assetID: PropTypes.string
  }).isRequired,
  loading: PropTypes.bool.isRequired,
  userID: PropTypes.string.isRequired,
  detailIndex: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  serverUpload: PropTypes.func.isRequired,
  assetCoatingSubstrate: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  assetCoatingSubstrateActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired
};
export { AssetDetailsItem as TestAssetDetailsItem };
export default entityComposition(AssetDetailsItem, ['assetCoatingSubstrate']);